// @ts-ignore
import LOGO from '@/assets/images/no-auth.svg';

const NoAuth = () => {
	return (
		<div style={{ marginTop: -8 }}>
			<div className="ttn-error-content">
				<div style={{ marginLeft: 100 }}>
					<img src={LOGO} />
				</div>
				<div className="ttn-error-tips">
					<span>很抱歉，您没有访问权限！</span>
				</div>
			</div>
		</div>
	);
};

export default NoAuth;
